import { render, staticRenderFns } from "./dashboardOverview.vue?vue&type=template&id=20b202a1&scoped=true"
import script from "./dashboardOverview.vue?vue&type=script&lang=js"
export * from "./dashboardOverview.vue?vue&type=script&lang=js"
import style0 from "./dashboardOverview.vue?vue&type=style&index=0&id=20b202a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b202a1",
  null
  
)

export default component.exports